import { Button } from '@cian/ui-kit';

import * as styles from './DobroListingPopupFooter.css';

export interface IDobroListingPopupFooterProps {
  onSaveClick: () => void;
  onCopyClick: () => void;
}

export function DobroListingPopupFooter(props: IDobroListingPopupFooterProps) {
  return (
    <div className={styles.buttons}>
      <Button onClick={props.onSaveClick} fullWidth>
        Сохранить
      </Button>
      <Button onClick={props.onCopyClick} theme="fill_secondary">
        Копировать
      </Button>
    </div>
  );
}
